import axios from 'apis';
import { getThunkActionCreator } from 'redux-thunk-routine';
import { sendConfirmationCodeRoutine, validateConfirmationCodeRoutine } from 'actions';

export const sendConfirmationCode = getThunkActionCreator(sendConfirmationCodeRoutine, async (email) => await axios.post(`/user/confirmations`, { email }));
export const validateConfirmationCode = getThunkActionCreator(validateConfirmationCodeRoutine, async ({ email, confirmation_code }) => await axios.post(`/user/confirmations/validate`, { email, confirmation_code }));
